import React from 'react';
import {Toaster} from 'react-hot-toast';
import {useTheme} from '../../contexts/ThemeContext';

export const GlobalToaster: React.FC = () => {
    const {isDarkMode} = useTheme();

    return (
        <Toaster
            position="top-right"
            toastOptions={{
                className: isDarkMode ? '!bg-slate-800 !text-white' : '',
            }}
        />
    );
};
